import CQPage from './ContractQuote';

export default CQPage;



// WEBPACK FOOTER //
// ./src/pages/contractQuote/index.jsx